var map = {
	"./Senior Fitness test assessment in geriatrics 1.jpeg": 12206,
	"./Senior Fitness test assessment in geriatrics 2.jpeg": 32955,
	"./Senior Fitness test assessment in geriatrics 3.jpeg": 86964,
	"./Senior Fitness test assessment in geriatrics.jpeg": 92957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75178;